module.exports = __webpack_public_path__ + "img/image3.2750b061.jpg";